export const CANCEL_USER_LOAD = 'CANCEL_USER_LOAD';
export const USER_LOADING = 'USER_LOADING'
export const USER_LOADED = 'USER_LOADED'
export const USER_LOADED_ERROR = 'USER_LOADED_ERROR'
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL'
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL'

export const API_CALL = 'API_CALL'
export const API_START = 'API_START'
export const API_ERROR = 'API_ERROR'
export const API_SUCCESS = 'API_SUCCESS'
export const API_END = 'API_END'
export const API_ACCESS_DENIED = 'API_ACCESS_DENIED'
export const PARSE_ERROR = 'PARSE_ERROR'

export const NEW_MESSAGE = 'NEW_MESSAGE'
